// extracted by mini-css-extract-plugin
module.exports = {"login-form":"Login_login-form__1oAzn","other":"Login_other__3Cunx"};